"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportFieldLineLayout = exports.ToolbarParent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = require("styled-components");
const ToolbarParent = (_a) => {
    var { layoutType } = _a, rest = tslib_1.__rest(_a, ["layoutType"]);
    return react_1.default.createElement("div", Object.assign({ "data-toolbar-layout-type": layoutType }, rest));
};
exports.ToolbarParent = ToolbarParent;
// ? Should this be extracted?
const supportFieldLineLayout = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
subSelector = '') => (0, styled_components_1.css) `
  [data-toolbar-layout-type='inner'] > & {
    & ${subSelector} {
      border-radius: 0;
    }
  }

  [data-toolbar-layout-type='vertical'] > & {
    &:first-child:not(:last-child) ${subSelector} {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child):not(:last-child) ${subSelector} {
      border-radius: 0;
    }
    &:last-child:not(:first-child) ${subSelector} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }

  [data-toolbar-layout-type='horizontal'] > & {
    &:first-child:not(:last-child) ${subSelector} {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child):not(:last-child) ${subSelector} {
      border-radius: 0;
    }
    &:last-child:not(:first-child) ${subSelector} {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`;
exports.supportFieldLineLayout = supportFieldLineLayout;
//# sourceMappingURL=toolbarParent.js.map